import { Employee } from '../employee/employee';
import { MissionRequest } from './mission-request';
import { Solution } from '../solution';
import { Route } from '../route';
import { State } from '../../enums/state.enum';
import { Parcours } from '../services-aide-emploi/parcours';

export class Mission {
	readonly id: number;
	plannedPosition: number;
	plannedStart: number;
	plannedEnd: number;
	plannedTravelStart: number;
	plannedTravelEnd: number;
	realizedPosition: number;
	realStart: number;
	realEnd: number;
	realTravelStart: number;
	realTravelEnd: number;
	missionRequest: MissionRequest;
	missionParent: Mission;
	planner: Employee;
	groupEvent: any;
	state: State;
	route: Route;
	solution: Solution;

	assignedEmployee?: Employee; // pour planning benef

	attendees: Employee[];

	constructor(
		options: {
			id?: number;
			plannedPosition?: number;
			plannedStart?: number;
			plannedEnd?: number;
			plannedDuration?: number;
			realizedPosition?: number;
			realStart?: number;
			realEnd?: number;
			realDuration?: number;
			missionRequest?: MissionRequest;
			planner?: Employee;
			groupEvent?: any;
			state?: State;
			route?: any;
			missionParent?: Mission;
			solution?: Solution;
			attendees?: Employee[];
		} = {}
	) {
		this.id = options.id || 0;
		this.plannedPosition = options.plannedPosition || null;
		this.plannedStart = options.plannedStart || null;
		this.plannedEnd = options.plannedEnd || null;
		this.realizedPosition = options.realizedPosition || null;
		this.realStart = options.realStart || null;
		this.realEnd = options.realEnd || null;
		this.missionRequest = options.missionRequest || null;
		this.missionParent = options.missionParent || null;
		this.planner = options.planner || null;
		this.groupEvent = options.groupEvent || null;
		this.state = options.state || null;
		this.route = options.route || null;
		this.solution = options.solution || null;
		this.attendees = options.attendees || [];
	}
}
